import {
  getYellowBannerEventsListAPI,
  postYellowBannerAPI,
  putYellowBannerAPI,
  deleteYellowBannerAPI,
} from "../api";

export default {
  namespaced: true,

  state: {
    data: {
      yellowBannerEvents: [],
      isLoading: false,
    },
  },

  getters: {
    getYellowBannerEvents: (state) => state.data.yellowBannerEvents,
    getYellowBannerLoading: (state) => state.data.isLoading,
  },

  actions: {
    actionGetYellowBannerEventsList({ commit, rootState }) {
      const { env } = rootState.selectEnv.data;
      commit("SET_IS_LOADING", true);
      return new Promise((resolve, reject) => {
        getYellowBannerEventsListAPI(env).then(
          (response) => {
            commit("SET_YELLOW_BANNER", response);
            setTimeout(() => {
              commit("SET_IS_LOADING", false);
            }, 1000);
            resolve(response);
          },
          (error) => {
            setTimeout(() => {
              commit("SET_IS_LOADING", false);
            }, 1000);
            reject(error);
          }
        );
      });
    },

    actionSetYellowBanner({ commit }, payload) {
      commit("SET_IS_LOADING", true);
      if (payload && !payload.eventKey) {
        return new Promise((resolve, reject) => {
          postYellowBannerAPI(payload)
            .then((res) => {
              resolve(res);
            })
            .catch((err) => {
              setTimeout(() => {
                commit("SET_IS_LOADING", false);
              }, 1000);
              console.log("err: ", err);
              reject(err);
            });
        });
      } else {
        return new Promise((resolve, reject) => {
          putYellowBannerAPI(payload)
            .then((res) => {
              resolve(res);
            })
            .catch((err) => {
              setTimeout(() => {
                commit("SET_IS_LOADING", false);
              }, 1000);
              console.log("err: ", err);
              reject(err);
            });
        });
      }
    },

    actionDeleteBannerEvent({ commit }, payload) {
      commit("SET_IS_LOADING", true);
      return new Promise((resolve, reject) => {
        deleteYellowBannerAPI(payload)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            setTimeout(() => {
              commit("SET_IS_LOADING", false);
            }, 1000);
            console.log("err: ", err);
            reject(err);
          });
      });
    },
  },

  mutations: {
    SET_YELLOW_BANNER(state, payload) {
      state.data.yellowBannerEvents = payload;
    },
    SET_IS_LOADING(state, payload) {
      state.data.isLoading = payload;
    },
  },
};
